/**
 * Created by dmitry on 08.10.2025
 */

cleverapps.InitByFeature["minigame_balloons"] = function (isNewUser) {
    cleverapps.miniGame = new cleverapps.MiniGame(isNewUser);
};